import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const markConversationsSpam = {
  name: "markConversationsSpam" as const,
  input: z.object({
    conversationIds: z
      .array(zExt.objectId())
      .min(1, "At least one conversation ID is required"),
  }),
  output: z.object({
    success: z.boolean(),
    processedConversations: z.number(),
    excludedEmails: z.array(z.string()),
  }),
};
